export enum STORAGE_KEYS {
    USER = 'user',
    AUTH = 'auth',
    WAIT_TO_RESEND_CODE = "wait_to_resend_code"
  }